module.exports = __webpack_public_path__ + "img/go-personal.65671e59.svg";